import React from 'react';
import { useHistory } from 'react-router-dom';

import { useMutation, useQueryClient } from '@sopranodesign/pulse-hooks';
import { PageWrapper, useNotification } from '@sopranodesign/pulse-components';

import { McpSkillDetails } from '../Components/index';
import { createSkill } from '../api/index';

const CreateMcpSkill = ({ match }) => {
  const history = useHistory();
  const { showSuccess } = useNotification();
  const queryClient = useQueryClient();

  // Pre-select the provider if coming from /mcp/providers/:providerId/skills/create
  const providerId = match?.params?.providerId
    ? Number(match.params.providerId)
    : null;

  const mutation = useMutation({
    mutationFn: createSkill,
    onSuccess: () => {
      showSuccess('Skill created');
      queryClient.invalidateQueries('mcp-skills');
      history.goBack();
    }
  });

  return (
    <PageWrapper
      header="Add MCP Skill"
      subheader="Define a skill exposed by a provider">
      <McpSkillDetails
        handleSubmit={form => mutation.mutate(form)}
        loading={mutation.isPending}
        initialSkill={providerId ? { mcp_skill_provider_id: providerId } : null}
      />
    </PageWrapper>
  );
};

export default CreateMcpSkill;
